import { AppRecordValidateResult } from '@xbcb/ui-types';
import { VneFieldValidator, VneValidationArgs } from '../types';
import { VneRequirements } from 'libs/pgaHelpers/epa';

export class BondNumberValidator implements VneFieldValidator {
  isApplicable(args: VneValidationArgs): boolean {
    const { vneImportCode } = args.pga;
    if (vneImportCode) {
      return VneRequirements.isBondPolicyNumberRequired(vneImportCode);
    }
    return false;
  }

  validate(_: VneValidationArgs): AppRecordValidateResult {
    return {
      validateFields: [['vneBondNumber']],
    };
  }
}
